export const COMMENT_MAX_LENGTH = 250
export const COMMENT_MAX_VISIBLE = 3 // Show max 3 comments before "View all"
export const COMMENT_POLLING_INTERVAL = 15000 // 15 seconds
export const COMMENT_QUERY_KEY = 'multiCartComments'
